import { apiv2GetEnvelope } from '@/lib/apiv2';

export interface PatientIntake {
  intake_id?: string | number;
  withings_user_id: string | number;
  intake_type?: string;
  submitted_at?: string;
  data?: Record<string, unknown>;
  [key: string]: unknown;
}

export interface ListPatientIntakesOpts {
  intakeType?: string;
  submittedAfter?: string;
  submittedBefore?: string;
  limit?: number;
  offset?: number;
}

// Returns the full {status, data, meta} envelope — consumers need meta.count for pagination.
export async function listPatientIntakes(
  withingsUserId: string | number,
  {
    intakeType, submittedAfter, submittedBefore, limit = 50, offset = 0,
  }: ListPatientIntakesOpts = {},
) {
  return apiv2GetEnvelope('patient-intakes', {
    withings_user_id: String(withingsUserId),
    intake_type: intakeType,
    submitted_after: submittedAfter,
    submitted_before: submittedBefore,
    limit,
    offset,
  });
}
